type ICacheValue<T = any> = {
  data: T;
  valid: number; // timestamp in ms
};

export class CacheUtility {
  private static cache: Record<string, ICacheValue<any>> = {};

  static save<T = any>(key: string, value: T, minutes = 10): void {
    CacheUtility.cache[key] = {
      data: Array.isArray(value) ? ([...value] as T) : ({ ...value } as T),
      valid: Date.now() + minutes * 60 * 1000,
    };
  }

  static get<T = any>(key: string): T | null {
    const cached = CacheUtility.cache[key];
    if (cached && cached.valid > Date.now()) {
      return cached.data as T;
    }
    return null;
  }

  static remove(key: string): void {
    delete CacheUtility.cache[key];
  }

  static containsRemoved(partialKey: string): void {
    const keys = Object.keys(CacheUtility.cache);
    const matchingKeys = keys.filter(k => k.includes(partialKey));
    matchingKeys.forEach(k => {
      CacheUtility.remove(k);
    });
  }

  static removeAll(): void {
    CacheUtility.cache = {};
  }
}

export const CacheTimes = {
  TWO_HOURS: 120,
} as const;
